"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/***
 * Slideshow
 */
var StopNGoShowroomConfigSlideshowMediaTypes;
(function (StopNGoShowroomConfigSlideshowMediaTypes) {
    StopNGoShowroomConfigSlideshowMediaTypes["IMAGE"] = "image";
    StopNGoShowroomConfigSlideshowMediaTypes["VIDEO"] = "video";
})(StopNGoShowroomConfigSlideshowMediaTypes = exports.StopNGoShowroomConfigSlideshowMediaTypes || (exports.StopNGoShowroomConfigSlideshowMediaTypes = {}));
var StopNGoShowroomConfigSlideshowUnit;
(function (StopNGoShowroomConfigSlideshowUnit) {
    StopNGoShowroomConfigSlideshowUnit["PERCENT"] = "percent";
    StopNGoShowroomConfigSlideshowUnit["PERSON"] = "person";
    StopNGoShowroomConfigSlideshowUnit["MINUTE"] = "minute";
})(StopNGoShowroomConfigSlideshowUnit = exports.StopNGoShowroomConfigSlideshowUnit || (exports.StopNGoShowroomConfigSlideshowUnit = {}));
/***
 * Sound config
 */
var StopNGoSoundType;
(function (StopNGoSoundType) {
    StopNGoSoundType["BEEP"] = "beep";
    StopNGoSoundType["VOICE"] = "voice";
})(StopNGoSoundType = exports.StopNGoSoundType || (exports.StopNGoSoundType = {}));
